import React, {useEffect, useState} from 'react';
import {Button, Card, Container, Modal, ModalBody, ModalHeader, Spinner} from 'reactstrap';
import DataTable from 'react-data-table-component';
import {collection, doc, getCountFromServer, getDoc, query, updateDoc, where} from 'firebase/firestore';
import {getDb} from 'util/Constants';
import CompetenciesModal from './CompeteciesModal';
import Swal from "sweetalert2";


export default function Competencies() {
    const [competencies, setCompetencies] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [btnLoad, setBtnLoad] = useState(false);
    const [load, setLoad] = useState(true);
    const [loader, setLoader] = useState();

    useEffect(() => {
        const fetchData = async () => {
            const docRef = doc(getDb(), 'Metadata_Games', 'competencies');
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                const data = docSnap.data().data;
                const updatedData = await Promise.all(data.map(async (competency) => {
                    const levelCounts = await getCountofLevels(competency.name);
                    const mergedCompetency = {
                        ...competency,
                        levelCounts: levelCounts.filter(level => level.ability === competency.name)
                    };
                    return mergedCompetency;
                }));

                setCompetencies(updatedData);
                setLoad(false)
            } else {
                setLoad(false)

            }
        };

        fetchData();
    }, []);


    const getCountofLevels = async (ability) => {
        const levelCounts = [];

        for (let i = 0; i < 7; i++) {
            const coll = collection(getDb(), 'Metadata_QuestionBank');
            const q = query(
                coll,
                where('ability', '==', ability),
                where('levelName', '==', (i + 1).toString())
            );
            const snapshot = await getCountFromServer(q);
            levelCounts.push({
                level: i + 1,
                count: snapshot.data().count,
                ability: ability
            });
        }

        return levelCounts;
    };

    const deleteData = async (item) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This action will permanently delete the Competency!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
            // reverseButtons: true,
        });

        // If user cancels, stop the deletion process
        if (!result.isConfirmed) return;
        setBtnLoad(item.name)
        const competenciesData = competencies.filter((e) => e.name !== item.name)
        const metaGamesRef = doc(getDb(), "Metadata_Games", "competencies");

        await updateDoc(metaGamesRef, {
            data: competenciesData
        });
        setCompetencies(competenciesData)
        setBtnLoad(null)
    }

    const toggleModal = (item) => {
        if (item?.hasOwnProperty("name")) {
            setSelectedItem(item);
        } else {
            setSelectedItem({})
        }
        setModalOpen((prev) => !prev);
    };

    const downloadCsv = (item) => {
        console.log(item);
        if (item) {
            window.open(item, "_blank");
        } else {
            console.log("No file placed, Please upload the file");
        }
    }


    const columns = [
        {
            name: 'Name',
            selector: (row) => row.name
        },
        {
            name: 'Description',
            selector: (row) => row.description
        },
        {
            name: 'Logo',
            center: true,
            selector: (row) => <img src={row.image} width="50" alt="Logo"/>
        },
        {
            name: 'Levels Each Ability',
            center: true,
            cell: (row) => (
                <div className="">
                    {row?.levelCounts?.map((e) => (
                        <div className="d-flex  mb-2">
                            <div className="mr-2">Level {e.level} =</div>
                            <div className="text-muted">{e.count}</div>
                        </div>
                    ))}
                </div>
            )
        },
        {

            name: '',
            // center: true,
            width: '250px',
            selector: row => null,
            cell: row => (
                <div className="d-flex justify-content-end w-100 px-2">
                    <Button
                        onClick={() => toggleModal(row)}
                        color="default"
                        size="sm"
                    >
                        <i className="fas fa-pen"/>
                    </Button>
                    <Button
                        onClick={() => downloadCsv(row.fileLink)}
                        color="default"
                        size="sm"
                    >
                        <i className="fas fa-download"/>
                    </Button>
                    <Button
                        onClick={() => deleteData(row)}
                        disabled={btnLoad === row.name}

                        color="danger"
                        size="sm"
                    >
                        {btnLoad === row.name ?
                            <Spinner
                                className="mx-2"
                                color={'white'}
                                size={'sm'}
                            >
                                Loading...
                            </Spinner> : <i className="fas fa-trash"/>}
                    </Button>
                </div>
            )
        }
    ];

    return (
        <>
            <Container fluid>
                <div className='d-flex justify-content-end'>
                    <Button
                        onClick={toggleModal}
                        color="default"
                    >
                        Add
                    </Button>
                </div>
                <Card>
                    <DataTable columns={columns} data={competencies} pagination={true} progressPending={load}
                    />
                </Card>
            </Container>
            <Modal isOpen={modalOpen} toggle={toggleModal}>
                <ModalHeader
                    toggle={toggleModal}>{selectedItem?.hasOwnProperty('name') ? 'Update' : 'Add'} Competency</ModalHeader>
                <ModalBody>
                    <CompetenciesModal isOpen={modalOpen} toggle={toggleModal} item={selectedItem}
                                       competencies={competencies} setCompetencies={setCompetencies}/>
                </ModalBody>
            </Modal>
        </>
    );
}
